// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const lineHeights = {
  mega: '1.0833',
  heading1: '1.1667',
  heading2: '1.3333',
  heading3: '1.1429',
  body: '1.3750',
  bodyS: '1.3333',
  label: '1.5000',
  labelS: '1.3333',
  button: '1.5000',
  buttonS: '1.0000'
} as const;

export default lineHeights;
